import React, { useState, useEffect, useRef } from "react";
import Modal from "./Modal";
import { getPostContentFromClassic, getPostContentFromGutenberg, getClassicBlockFromGutenbergIframe, isClassicEditorActive } from "./appComponent/wordpressPostContent";
import { punctuation, wordWrapHandler } from "./appComponent/wordWrap";
import fetchBatchContent from "./appComponent/ajax";

/* global wp */

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [matches, setMatches] = useState([]);
  const [editableContent, setEditableContent] = useState("");
  const [wordOffsets, setWordOffsets] = useState([]);

  const counterRef = useRef(0);

  useEffect(() => {
    initializeScanButton();
  }, []);
  
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("wordgrd-no-scroll");
    } else {
      document.body.classList.remove("wordgrd-no-scroll");
    }

    // cleanup if component unmounts
    return () => {
      document.body.classList.remove("wordgrd-no-scroll");
    };
  }, [isOpen]);

  // handle scan button click
  function initializeScanButton() {
    const btn = document.getElementById("wordgrd-scan-button");
    if (!btn) return;

    const handleClick = () => {
      let postHeading = "";
      let postContent = "";

      // First, try Gutenberg
      if (isClassicEditorActive()) {
        // Gutenberg not available, fallback to classic
        const classicData = getPostContentFromClassic();
        postHeading = classicData.postHeading || "";
        postContent = classicData.postContent || "";

      } else if (typeof wp !== "undefined" && wp.data) {
        const data = getPostContentFromGutenberg();
        postHeading = data.postHeading || "";
        postContent = data.postContent || "";

        // If both heading and content are empty, fallback to classic editor
        if (!postHeading || !postContent) {
          const classicData = getClassicBlockFromGutenbergIframe();
          postContent = classicData.postContent || "";
        }
      }


      setTitle(postHeading || "<p>No title found</p>");
      setEditableContent(postContent);
      setIsOpen(true);

      // scan via AJAX
      scanContentInBatches(postContent);
    };

    // remove any existing listener to prevent duplicates
    btn.removeEventListener("click", handleClick);
    btn.addEventListener("click", handleClick);
  };

  function scanContentInBatches(content) {
    fetchBatchContent(content).then(matches => {
      if (matches.length > 0) {
        wordWraphandler(matches, content); // highlight all matches at once
      } else {
        setMatches([]);
        setWordOffsets([]);
        setEditableContent(content);
      }
    });
  }

  function wordWraphandler(matches, content) {
    const { highlighted, wordOffsets } = wordWrapHandler(matches, content, punctuation, counterRef);
    setMatches(matches);
    setEditableContent(highlighted);
    setWordOffsets(wordOffsets);
  }

  // Adjust sidebar z-index to overlay
  function useSidebarOverlay(isOpen) {
    useEffect(() => {
      const sidebarTabs = document.querySelector(
        ".interface-complementary-area .components-panel__header"
      );
      if (!sidebarTabs) return;

      // Set z-index based on isOpen
      sidebarTabs.style.zIndex = isOpen ? "0" : "1";

      // Cleanup on unmount
      return () => {
        if (sidebarTabs) {
          sidebarTabs.style.zIndex = "";
        }
      };
    }, [isOpen]);
  }

  function onClose() {
    setIsOpen(false);
    setEditableContent("");   // clear old highlighted text
    setMatches([]);
    setWordOffsets([]);
    counterRef.current = 0;
  }

  useSidebarOverlay(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      title={title}
      content={editableContent}
      matches={matches}
      wordOffsets={wordOffsets}
    />
  );

}

export default App;
